import React from 'react';
import { useNavigate } from 'react-router-dom';

export const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="shadow-sm sticky-top" style={{ backgroundColor: '#000000' }}>
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between py-3 px-4">
          <div className="d-flex align-items-center" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            <img src="/logo/image.png" alt="Logo" style={{ height: '40px', marginRight: '15px' }} />
            <h4 className="mb-0" style={{ color: '#ffffff' }}>Operate Explorer</h4>
          </div>
        </div>
      </div>
    </header>
  );
};
